<template>
  <b-card>
    <b-row>
      <b-col md="7" class="p-0">
        <div class="my-2 mb-4 ml-4 mr-4">
          <h1>Create Stock Point</h1>
          <v-stepper alt-labels v-model="e1">
            <v-stepper-header>
              <template v-for="(list, index) in getSteppersList">
                <v-stepper-step
                  :step="index + 1"
                  :key="index + list"
                  class="v-stepper-step-outline"
                  >{{ list }}</v-stepper-step
                >
                <v-divider
                  v-if="index !== getSteppersList.length - 1"
                  :key="index + list"
                />
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content :step="getSteps('office')">
                <s-office
                  @place_changed="setPlace"
                  :isBillTo="false"
                  :tenants="tenants"
                >
                  <template v-slot:footer-button="data">
                    <b-button
                      class="btn btn-block mt-3"
                      btn-color="primary"
                      @click="OfficeToNext(data.data)"
                      >Next</b-button
                    >
                  </template>
                </s-office>
              </v-stepper-content>

              <v-stepper-content :step="getSteps('organization')">
                <s-organization
                  @place_changed="setPlace"
                  :officeData="office"
                  :isLightMode="isLightConfiguration"
                >
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 1" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="OrgToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-organization>
              </v-stepper-content>

              <v-stepper-content
                :step="getSteps('billTo')"
                v-if="!isLightConfiguration"
              >
                <s-office
                  :isBillTo="true"
                  :officeData="office"
                  :setValues="useOfficeDataInBillTo"
                >
                  <template v-slot:name="billname">
                    <c-input
                      inputType="text"
                      inputId="name"
                      lableText="Bill Name"
                      v-model="billname.data"
                      class="mt-3"
                    />
                  </template>
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn flat @click="e1 = 2" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="BillToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-office>
              </v-stepper-content>

              <v-stepper-content :step="getSteps('authentication')">
                <s-authentication
                  :officeData="office"
                  :isLightMode="isLightConfiguration"
                >
                  <template v-slot:footer-button="data">
                    <b-row class="mt-3">
                      <b-col md="2">
                        <v-btn
                          v-if="!isLightConfiguration"
                          flat
                          @click="e1 = 3"
                          btn-back="primary"
                        >
                          <span class="fa fa-reply"></span>
                        </v-btn>
                        <v-btn v-else flat @click="e1 = 2" btn-back="primary">
                          <span class="fa fa-reply"></span>
                        </v-btn>
                      </b-col>
                      <b-col md="10">
                        <b-button
                          class="btn btn-block"
                          btn-color="primary"
                          @click="AuthToNext(data.data)"
                          >Next</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </s-authentication>
              </v-stepper-content>

              <v-stepper-content :step="getSteps('done')">
                <s-thanks @done="done"></s-thanks>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </div>
      </b-col>
      <b-col md="5" col-4="image" class="p-0">
        <img
          src="img/svg/createAccount.svg"
          class="img-avatar"
          v-if="e1 != 2 && e1 != 1"
        />
        <div v-else>
          <GmapMap
            :center="position"
            :zoom="7"
            map-type-id="terrain"
            style="width: 540px; height: 541px"
          >
            <GmapMarker
              v-if="this.place"
              label="★"
              :draggable="false"
              :position="position"
            />
          </GmapMap>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import sOffice from "@/components/SubOffice/OfficeStepper.vue";
import sOrganization from "@/components/Partner/OrganizationStepper.vue";
import sAuthentication from "@/components/Partner/AuthenticationStepper.vue";
import sThanks from "@/components/SubOffice/ThankYouStepper.vue";
import sAgreement from "@/components/Partner/Agreement.vue";
import { getReverseGeoCode } from "@/services/geocode";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateOffice",
  components: {
    sOffice,
    sOrganization,
    sAuthentication,
    sThanks,
    sAgreement,
    cInput,
  },
  data() {
    return {
      loading: false,
      e1: 0,
      tenants: [],
      office: null,
      organization: null,
      billTo: null,
      authentication: null,
      agreement: null,
      markers: [],
      place: null,
      isLightConfiguration: true,
      useOfficeDataInBillTo: true,
      position: {
        lat: 0,
        lng: 0,
      },
    };
  },
  mounted() {
    this.isLightConfiguration = this.tenantPreferences.lightMode;
    this.catalogDomainData = this.$currentUserData.catalogInfo;
  },
  computed: {
    getSteppersList() {
      const data = [];
      data.push("Office");
      data.push("Organization");
      if (!this.isLightConfiguration) {
        data.push("Bill_To");
      }
      data.push("Authentication");
      data.push("Done");
      return data;
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    ...mapGetters({
      getCategoryList: "catalog/GetCategoryList",
      tenantPreferences: "tenant/GetTenantPreferences",
    }),
  },
  methods: {
    getSteps(key) {
      if (!this.isLightConfiguration) {
        switch (key) {
          case "office":
            return 1;
          case "organization":
            return 2;
          case "billTo":
            return 3;
          case "authentication":
            return 4;
          case "done":
            return 5;
        }
      } else {
        switch (key) {
          case "office":
            return 1;
          case "organization":
            return 2;
          case "authentication":
            return 3;
          case "done":
            return 4;
        }
      }
    },
    async OfficeToNext(item) {
      console.log(item);
      this.office = item;
      this.e1 = 2;
    },
    async OrgToNext(item) {
      if (item.name != "") {
        this.organization = item;
        this.e1 = 3;
      } else {
        this.$swal({
          title: "Error",
          text: "Please fillup required fields.",
          type: "error",
        });
      }
    },
    async BillToNext(item) {
      this.billTo = item;
      try {
        const data = await getReverseGeoCode(
          `${this.billTo.address.street1},${this.billTo.address.city},${this.billTo.address.state},${this.billTo.address.country}`
        );
        if (data.data.status === "OK") {
          this.billTo.address.location = {
            coordinates: [
              data.data.results[0].geometry.location.lat,
              data.data.results[0].geometry.location.lng,
            ],
          };
        }
        this.e1 = 4;
      } catch (error) {}
    },
    async AuthToNext(item) {
      this.authentication = item;
      const { organization, billTo, office, authentication } = this;
      const authenticationCopy = { ...authentication };
      console.log(item, authentication, authenticationCopy);
      authenticationCopy.securityQuestions = {
        question: authentication.securityQuestions.question.value,
        answer: authentication.securityQuestions.answer,
      };
      if (!authenticationCopy.passwordValid) {
        this.$swal({
          title: "Password Validation failed.",
          text: "Enter a strong password !!!",
          type: "warning",
        });
        return;
      }
      delete authenticationCopy.passwordValid;
      office.officeType = office.officeType.value;
      delete authenticationCopy.securityQA;
      let authorization = {};
      let orgaccess = [];
      if (
        organization.orgAccessList !== null &&
        organization.orgAccessList.length > 0
      ) {
        organization.orgAccessList.map((obj) => {
          orgaccess.push(obj._id);
        });
      }

      authorization.orgAccess = {
        orgAccessLevel: "Global",
        orgAccessList: orgaccess,
      };

      delete organization.orgAccessLevel;
      delete organization.orgAccessList;
      const payload = {
        authentication: authenticationCopy,
        billTo,
        office,
        organization,
        agreement: {},
        category: office.category.value,
      };

      payload.officeHierarchy = this.$store.getters["auth/getUserID"];
      console.log(payload);

      this.loading = true;
      this.$store
        .dispatch("partner/createPartner", payload)
        .then((result) => {
          console.log("result : ", result);
          this.loading = false;
          this.$swal({
            title: "Success",
            text: "Stockpoint created successfully!",
            type: "success",
          });
          if (this.isLightConfiguration) {
            this.e1 = 4;
          } else {
            this.e1 = 5;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.e1 = 1;
          this.$swal({
            title: "Error",
            text: "Could not create stockpoint",
            type: "error",
          });
        });
    },
    done() {
      this.e1 = 1;
      this.$router.push({ path: "/suboffice-management" });
    },
    async setPlace(p) {
      let place = await p;
      let position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.position = position;
    },
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}
[col-4="image"] {
  background-color: aliceblue !important;
}
[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
.img-avatar {
  margin-top: 150px !important;
}
</style>
<style>
.v-stepper {
  box-shadow: none;
  /* padding: 19px; */
}

.v-stepper__header {
  box-shadow: none;
}

.v-btn:before {
  opacity: -0.12 !important;
}

.v-stepper--alt-labels .v-stepper__step {
  flex-basis: 0px;
}

.v-stepper-step-outline {
  border: 1px solid #727cf5 !important;
  height: 0px;
  border-radius: 50%;
  width: 0px;
  margin-top: 8px;
  /* margin-right: 0px; */
  /* margin-left: 0; */
  margin-bottom: 40px;
  float: left;
}
@-moz-document url-prefix() {
  .v-stepper-step-outline {
    padding: 24px 4px 24px 4px;
  }
}

/* Active Tab Class*/
.theme--light.v-stepper .v-stepper__step__step,
.theme--light.v-stepper .v-stepper__step__step .v-icon {
  color: #ffffff;
  background-color: #727cf5 !important;
}

.v-stepper--alt-labels .v-stepper__step__step {
  margin-right: 0;
  margin-bottom: 22px;
  margin-top: -21px;
}
.v-stepper__step__step {
  min-height: 42px;
  min-width: 42px !important;
}
.v-stepper__content {
  padding: 0px !important;
  margin-top: 25px;
}
/* Deactive Stepper */
.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  background: #8badd6 !important;
}
/* divider between stepper */
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px 0px;
  -ms-flex-item-align: start;
  align-self: flex-start;
}
</style>
